import styled, { css } from 'styled-components';

export const ManageSection = styled.section`
  margin: 0 -25px;
  margin-bottom: 50px;
`;

export const ManageContainer = styled.div`
  position: relative;
  z-index: 2;

  display: flex;
  justify-content: flex-end;
  width: 205px;
`;

export const ManageButton = styled.button`
  position: relative;

  height: 100%;
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};

  transition: color 0.3s;

  &::after {
    content: '';

    transform: rotate(90deg);

    display: inline-block;
    width: 6px;
    height: 9px;
    margin-left: 20px;

    background: transparent no-repeat center / contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%232CB8FE' fill-rule='evenodd' stroke='%232CB8FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");

    transition: background-image 0.3s, margin-left 0.3s;

    pointer-events: none;
  }

  &:hover {
    color: ${({ theme }) => theme.black};

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%23505050' fill-rule='evenodd' stroke='%23505050' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");
    }
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      &::after {
        transform: rotate(270deg);
      }
    `}
`;

export const ManageDropdown = styled.ul`
  position: absolute;
  z-index: 1;
  bottom: -10px;
  right: 0;
  min-width: 180px;
  transform: translateY(100%);
  margin: 0;
  padding: 10px 0;
  
  white-space: nowrap;

  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  border-radius: 6px 6px 12px 12px;

  button,
  .react-add-to-calendar__button {
    width: 100%;
    margin: 0;
    padding: 10px 20px;

    font-size: 16px;
    line-height: 1;
    text-align: left;

    cursor: pointer;

    transition: color 0.3s, background-color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.blue};

      background-color: #f8f8f8;
    }

    &.cancel {
      color: ${({ theme }) => theme.red};
    }
  }

  .react-add-to-calendar {
    position: relative;

    user-select: none;

    &::after {
      content: '';

      position: absolute;
      top: 18px;
      transform: translateY(-50%) rotate(90deg);
      right: 20px;

      display: inline-block;
      width: 6px;
      height: 9px;
      margin-left: 20px;

      background: transparent no-repeat center / contain;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%232CB8FE' fill-rule='evenodd' stroke='%232CB8FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");

      transition: background-image 0.3s, margin-left 0.3s;

      pointer-events: none;
    }

    .react-add-to-calendar__button {
      display: inline-block;
      width: 100%;
    }
  }

  .react-add-to-calendar__dropdown {
    a {
      display: inline-block;
      width: 100%;
      padding: 10px 20px;
      padding-left: 30px;

      color: ${({ theme }) => theme.blue};

      transition: background-color 0.3s;

      &:hover {
        background-color: #f8f8f8;
      }
    }
  }
`;

export const ManageList = styled.ul`
  margin: 0;
  padding: 0;

  li:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
  }

  button,
  .react-add-to-calendar__button {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 20px 25px;

    font-weight: 700;
    font-size: 14px;
    line-height: 1;

    border: 0;

    transition: color 0.3s;

    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.blue};
    }

    &::after {
      content: '';

      width: 6px;
      height: 9px;

      background: transparent no-repeat center / contain;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%232CB8FE' fill-rule='evenodd' stroke='%232CB8FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");

      pointer-events: none;

      transition: transform 0.3s;
    }

    &.react-add-to-calendar__button--light::after {
      transform: rotate(90deg);
    }
  }

  .react-add-to-calendar__dropdown {
    a {
      display: inline-block;
      width: 100%;
      padding: 20px 25px;

      font-weight: 700;
      font-size: 14px;
      color: ${({ theme }) => theme.blue};

      transition: background-color 0.3s;

      &:hover {
        background-color: #f8f8f8;
      }
    }
  }
`;
